import React, { useContext, useEffect, useState } from "react";
import {
  FaPaperPlane,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";

import { GlobalContext } from "../Context/GlobalState";
const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  const { userdetail, setTransactionLoaderState } = useContext(GlobalContext);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
  };

  return (
    <div>
      <Row>
        <Col md={7} className="p-3 bg-white">
          <h4 className="mb-2">Send us a Query</h4>
          <Form onSubmit={handleSubmit}>
            <Row className="p-0 m-0">
              <Col md={6} className="px-1">
                <Form.Group>
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="px-1">
                <Form.Group>
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your e-mail"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="p-0 m-0">
              <Col md={6} className="px-1">
                <Form.Group>
                  <Form.Label>Phone</Form.Label>
                  <Form.Control
                    type="text"
                    name="phone"
                    placeholder="Enter mobile number"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="p-0 m-0">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="message"
                placeholder="Enter your query"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              className="d-flex align-items-center mt-2"
            >
              <FaPaperPlane className="me-2" /> Send Message
            </Button>
          </Form>
        </Col>

      
      </Row>
    </div>
  );
};

export default ContactForm;
